<template>
	<div class="choose__div--box">
		<div class="choose__div--radio">
			<el-radio-group
				style="display: flex; flex-wrap: wrap; text-align: left"
				v-model="wareCode"
			>
				<el-radio
					style="width: 80px; margin-bottom: 12px"
					v-for="item in options"
					:key="item.wareCode"
					:label="item.wareCode"
					v-model="wareCode"
					>{{ item.wareName }}
				</el-radio>
			</el-radio-group>
		</div>
		<div class="choose__div--btn">
			<el-button
				style="padding-right: 40px; padding-left: 40px"
				@click="backLogin"
				icon="el-icon-back"
				>{{ t("返回登录") }}</el-button
			>
			<el-button
				style="padding-right: 40px; padding-left: 40px"
				type="primary"
				@click="enterFN"
				icon="el-icon-thumb"
			>
				{{ t("进入仓库") }}
			</el-button>
		</div>
	</div>
</template>

<script>
import { t } from "@/i18n/index";
import { setUerWarehouse, checkJurisdiction } from "@/apis/auth";

import store from "@/store";
import { dev } from "@/const/env";
export default {
	name: "ChooseStorehouse",
	data() {
		return {
			t,
			wareCode: "",
		};
	},
	computed: {
		options: function () {
			return this.$store.getters.getWarehouses;
		},
	},
	methods: {
		backLogin: function () {
			this.$emit("change", {
				comName: "Login",
			});
		},
		enterFN: function (formName) {
			const that = this;
			if (that.wareCode && that.wareCode !== "") {
				checkJurisdiction().then(({ code, data }) => {
					if (code === 0) {
						if (
							data.warehouses.some((item) => item.wareCode === that.wareCode)
						) {
							setUerWarehouse({ wareCode: that.wareCode }).then(({ code }) => {
								if (code === 0) {
									this.$emit("change", {
										comName: "Login",
									});
									that.$store.dispatch("auth/setWareCode", that.wareCode);
									const warehouse = that.options.find(
										(v) => v.wareCode === that.wareCode
									);
									if (warehouse.wareNation) {
										// wareType 仓库类型 1杭州仓 2 片山仓 3 标准仓
										window.sessionStorage.setItem(
											"wareType",
											warehouse.wareName === "片山倉庫" ? "2" : "3"
										);
										//  日本用户进入默认日文
										window.localStorage.setItem("lang", "ja");
										if (dev()) {
											window.location.href =
												"http://localhost:8088/overseas/welcome?isRefresh=1";
											return;
										}
										window.location.href = "/overseas/welcome?isRefresh=1";
										return;
									} else {
										window.localStorage.setItem("lang", "zh");
									}
									window.sessionStorage.setItem("wareType", "1");
									that.$router.push("/welcome?isRefresh=1");
								}
							});
						} else {
							that.$message.warning(this.t("无权限"));
						}
					}
				});
			}
		},
	},
};
</script>

<style scoped>
.choose__div--box {
	height: 200px;
	padding: 20px;
}

.choose__div--radio {
	background: #f6f6f6;
	padding: 20px;
	border-radius: 10px;
}

.choose__div--btn {
	padding: 20px 0;
	display: flex;
	justify-content: flex-end;
	align-content: center;
}
</style>
